<ng-container *appAction="{ action: 'desktopAgentBanner', item: true }">
    <div *ngIf="visible" class="relative my-2 mx-2 flex items-center gap-4 p-4 pr-10 rounded-xl border border-primary-200 bg-primary-50 dark:border-primary-800 dark:bg-primary-900/20">
        <div class="flex items-center justify-center w-11 h-11 rounded-xl bg-primary-600 dark:bg-primary-500 text-white shrink-0">
            <svg class="w-6 h-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                <rect x="2.5" y="4" width="19" height="12.5" rx="2"/>
                <path d="M9 20h6M12 16.5V20"/>
                <path d="M12 7v5.5M9.5 10.2 12 12.7l2.5-2.5"/>
            </svg>
        </div>

        <div class="min-w-0 flex-auto">
            <div class="text-sm font-semibold text-gray-900 dark:text-white">Open and edit files right from your desktop</div>
            <p class="text-sm text-gray-500 dark:text-gray-400 mt-0.5">
                Install LollyDrive to open and edit documents using your native desktop applications. Every save comes straight back to LollyLaw — no downloading and re-uploading.
            </p>
        </div>

        <button mat-flat-button [color]="'primary'" class="ml-auto shrink-0 !rounded-full" (click)="install()">
            <span class="flex items-center gap-2">
                <mat-icon class="icon-size-5" svgIcon="feather:download"></mat-icon>
               <span class="text-base leading-normal">
                Install LollyDrive
               </span>
            </span>
        </button>

        <button mat-icon-button class="absolute top-2 right-2 shrink-0" matTooltip="Dismiss" (click)="dismiss()">
            <mat-icon class="icon-size-4" svgIcon="heroicons_outline:x-mark"></mat-icon>
        </button>
    </div>
</ng-container>
